import * as React from 'react';
import { useState } from 'react';
import StandardModal from '../../common/modals/StandardModal';
import { Grid, Button } from '../../common';
import { Select, Textarea } from '../../common';

interface ExtendPocModalProps {
    visible: boolean;
    accountName: string;
    accountId: number | undefined;
    onConfirm: (pocDurationDays: number, reason: string) => void;
    onCancel: () => void;
}

const ExtendPocModal: React.FC<ExtendPocModalProps> = ({
    visible,
    accountName,
    accountId,
    onConfirm,
    onCancel,
}) => {
    const [pocDurationDays, setPocDurationDays] = useState<number | null>(null);
    const [reason, setReason] = useState<string>('');

    const handleConfirm = () => {
        if (pocDurationDays && reason.trim()) {
            onConfirm(pocDurationDays, reason);
            setPocDurationDays(null);
            setReason('');
        }
    };

    const handleCancel = () => {
        setPocDurationDays(null);
        setReason('');
        onCancel();
    };

    return (
        <StandardModal
            show={visible}
            onDismiss={handleCancel}
            title={`Extend ${accountName} #${accountId}`}
            footer={
                <Grid>
                    <Grid.Item>
                        <Button
                            variant="secondary"
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                    </Grid.Item>
                    <Grid.Item>
                        <Button
                            onClick={handleConfirm}
                            disabled={!pocDurationDays || !reason.trim()}
                        >
                            Confirm
                        </Button>
                    </Grid.Item>
                </Grid>
            }
        >
            <Select
                label="Extension Duration"
                value={pocDurationDays?.toString() ?? ''}
                onChange={(e) =>
                    setPocDurationDays(parseInt(e.target.value))
                }
                options={[
                    { text: 'Select duration...', value: '' },
                    { text: '30 days', value: '30' },
                    { text: '60 days', value: '60' },
                    { text: '90 days', value: '90' },
                ]}
            />

            <Textarea
                label="Reason for extension"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                validation={{ required: true }}
            />
        </StandardModal>
    );
};

export default ExtendPocModal;